import React from 'react'
import { Box, Card, Typography } from '@mui/material'
import { featureCardIconBlobSx } from '@/theme/skinSx'

/**
 * Feature card component for landing page
 * Displays individual features with icon, title, and description
 */
const ICON_COLORS = {
  'text-danger': '#f83245',
  'text-warning': '#f4772e',
  'text-success': '#1bc943',
  'text-first': '#4191ff',
}

const FeatureCard = ({
  icon,
  title,
  description,
  iconColor = 'text-danger',
  className = '',
  sx,
}) => {
  return (
    <Card
      className={className}
      sx={[[{
        transition: "all 0.2s ease-in-out !important",
        "&:hover": { boxShadow: "0 0.56875rem 3.3875rem rgba(59, 62, 102, 0.05), 0 0.9975rem 2.40625rem rgba(59, 62, 102, 0.07), 0 0.35rem 1.23125rem rgba(59, 62, 102, 0.05), 0 0.225rem 1.1875rem rgba(59, 62, 102, 0.09)", transform: "translateY(-15px)" },
        "&.card-box-hover:hover": { boxShadow: "0 0.56875rem 3.3875rem rgba(59, 62, 102, 0.05), 0 0.9975rem 2.40625rem rgba(59, 62, 102, 0.07), 0 0.35rem 1.23125rem rgba(59, 62, 102, 0.05), 0 0.225rem 1.1875rem rgba(59, 62, 102, 0.09)", transform: "translateY(0)" },
      }, {
        "&:hover": { transform: "translateY(0)" },
      }],
        {
          textAlign: 'center',
          p: '1rem',
          display: 'block',
          borderRadius: '0.29rem',
          '@media (min-width: 1440px)': {
            padding: '1.5rem',
            marginBottom: '3rem',
          },
        },
        sx]}
    >
      <Box sx={featureCardIconBlobSx(ICON_COLORS[iconColor] || iconColor)}>
        <Box component="svg" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" sx={{ opacity: "0.1 !important" }} data-hf="blob-wrapper">
          <g transform="translate(300,300)">
            <path
              d="M169,-144C206.7,-87.5,216.5,-18,196.9,35.7C177.3,89.4,128.3,127.1,75.2,150.7C22,174.2,-35.4,183.5,-79.7,163.1C-124,142.7,-155.1,92.6,-164.1,40.9C-173.1,-10.7,-160.1,-64,-129,-118.9C-98,-173.8,-49,-230.4,8.3,-237.1C65.7,-243.7,131.3,-200.4,169,-144Z"
              fill="currentColor"
            />
          </g>
        </Box>
        <Box data-hf="blob-icon-wrapper">{icon}</Box>
      </Box>
      <Typography variant="h5" sx={[{ fontWeight: 700, mb: '0.5rem', color: '#070919' }, { fontSize: "1.15rem !important" }]}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ mb: '1.5rem', color: 'rgba(7, 9, 25, 0.5)' }}
      >
        {description}
      </Typography>
    </Card>
  )
}

export default FeatureCard
